<template>
  <div>
    <attach-cases-without-anomalies-to-invoice-form :invoice-id="invoiceId"/>
    <with-invoice :invoice-id="invoiceId">
      <template slot="default" slot-scope="{invoice}">
        <div v-if="invoice.status === 'Draft'">
          Filter:
          <v-layout>
            <v-btn-toggle v-model="logMode">
              <v-btn flat value="FromInvoice">
                In Invoice
              </v-btn>
              <v-btn flat value="FromDateRange">
                Not in Invoice
              </v-btn>
              <v-btn flat value="FromInvoiceOrDateRange">
                All
              </v-btn>
            </v-btn-toggle>
          </v-layout>
        </div>
        <div v-else>
          <!--empty-->
        </div>
      </template>
    </with-invoice>

    <div>
      <v-text-field
        label="Title"
        v-model="title"
      />
    </div>

    <with-invoice :invoice-id="invoiceId"
                  v-if="logMode === 'FromDateRange' || logMode==='FromInvoiceOrDateRange'">
      <template slot="default" slot-scope="slotProps">
        <date-range-input
          v-if="slotProps.invoice.status === 'Draft'"
          v-model="dateRange"
          label="Event date"
          :required="false"
          :disabled="false"
          :from-value-post-processor="setTimeToStartOfDay"
          :to-value-post-processor="setTimeToEndOfDay"/>
      </template>
    </with-invoice>

    <div>
      MetaFilter:
      <v-btn-toggle v-model="metaFilter" row>
        <v-btn flat v-for="metaFilter in availableMetaFilters" :value="metaFilter">
          {{prettifyOption(metaFilter)}}
        </v-btn>
      </v-btn-toggle>
    </div>

    <v-layout>
      <v-flex xs2>
        <v-checkbox label="With anomalies" false-value="All" true-value="WithAnomalies" v-model="caseAnomalyFilter"/>
      </v-flex>

      <v-flex xs2>
        <v-checkbox v-model="executedPriceOver9000" label="executedPriceOver9000"/>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import _ from 'lodash'
  import {GetFilteredCaseAnomalies, GetFilteredMetaFilters} from '../../../services/CaseServiceLogService'
  import DateRangeInput from '../../../components/Ui/DateRangeInput'
  import DevMode from '../../../components/Ui/DevMode'
  import ServicesSelect from '../../../components/Ui/mcc/ServicesSelect'
  import Filter6xx from "../../../components/analytics/Filter6xx";
  import {setTimeToEndOfDay, setTimeToStartOfDay} from '../../../helpers/date'
  import WithInvoice from './WithInvoice'
  import AttachCasesWithoutAnomaliesToInvoiceForm from "./AttachCasesWithoutAnomaliesToInvoiceForm";

  export default {
    name: 'invoice-candidate-logs-filters',
    components: {
      ServicesSelect,
      DateRangeInput,
      Filter6xx,
      DevMode,
      WithInvoice,
      AttachCasesWithoutAnomaliesToInvoiceForm
    },
    props: {
      invoiceId: {
        type: Number,
        required: true,
      }
    },
    data() {
      return {}
    },
    computed: {
      filter() {
        return this.$store.getters.getInvoiceLogCandidatesSection(this.invoiceId).filter
      },
      clientFilter() {
        return this.$store.getters.getInvoiceLogCandidatesSection(this.invoiceId).clientFilter
      },
      caseAnomalyFilter: {
        get() {
          return this.filter.caseAnomalyFilter
        },
        set(newValue) {
          this.changeFilter({
            invoiceId: this.invoiceId,
            filterDelta: {
              caseAnomalyFilter: newValue
            }
          })
        }
      },
      logMode: {
        get() {
          return this.filter.logMode
        },
        set(newValue) {
          this.changeFilter({
            invoiceId: this.invoiceId,
            filterDelta: {
              logMode: newValue
            }
          })
        }
      },
      title: {
        get() {
          return this.filter.title
        },
        set(newValue) {
          let modifiedNewValue = newValue;
          if (!modifiedNewValue) { // cast empty string to null
            modifiedNewValue = null
          }
          this.changeFilter({
            invoiceId: this.invoiceId,
            filterDelta: {
              title: modifiedNewValue
            }
          })
        }
      },
      dateRange: {
        get() {
          return this.filter.dateRange
        },
        set(newValue) {
          this.changeFilter({
            invoiceId: this.invoiceId,
            filterDelta: {
              dateRange: newValue
            }
          })
        }
      },
      metaFilter: {
        get() {
          if (this.filter.metaFilters.length === 0) {
            return null
          }
          return this.filter.metaFilters[0]
        },
        set(newValue) {
          let newArrayResult = [];
          if (newValue) {
            newArrayResult = [newValue]
          }
          this.changeFilter({
            invoiceId: this.invoiceId,
            filterDelta: {
              metaFilters: newArrayResult
            }
          })
        }
      },
      caseAnomalies: {
        get() {
          if (this.clientFilter.caseAnomalies.length === 0) {
            return null
          }
          return this.clientFilter.caseAnomalies[0]
        },
        set(newValue) {
          let newArrayResult = [];
          if (newValue) {
            newArrayResult = [newValue]
          }

          this.changeClientFilter({
            invoiceId: this.invoiceId,
            filterDelta: {
              caseAnomalies: newArrayResult
            }
          })
        }
      },
      executedPriceOver9000: {
        get() {
          return this.clientFilter.executedPriceOver9000
        },
        set(newValue) {
          this.changeClientFilter({
            invoiceId: this.invoiceId,
            filterDelta: {
              executedPriceOver9000: newValue
            }
          })
        }
      },
      availableMetaFilters() {
        return _.keys(GetFilteredMetaFilters)
      },
      availableCaseAnomalies() {
        return _.keys(GetFilteredCaseAnomalies)
      }
    },
    methods: {
      ...mapActions({
        changeFilter: 'invoicesChangeFilterForInvoiceLogCandidates',
        changeClientFilter: 'invoicesChangeClientFilterForInvoiceLogCandidates'
      }),
      prettifyOption(option) {
        return _.snakeCase(option).replace(/_/g, ' ')
      },
      setTimeToStartOfDay(value) {
        return setTimeToStartOfDay(value)
      },
      setTimeToEndOfDay(value) {
        return setTimeToEndOfDay(value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/InvoiceCandidateLogsFilters.vue